export default __webpack_public_path__ + "static/media/12-19.f44fb925.png";